<template>
  <div v-if="$props.includeHeader" class="hello screen-spacing">
        <label class="me-2 h4" for="dropdown">
          Select Location
          <span v-if="$props.optional" style="color: grey;"> (Optional)</span>:
        </label>
        <select :key="tracker" id="dropdown" class="form-select" v-on:change="updateBar($event)">
       <option v-for="(item,index1) in barList" :key="index1" class="card mx-3" :value="item._id">{{item.name}}</option>
    </select>
  </div>
  <div v-else>
    <select :key="tracker" id="dropdown" class="form-select" v-model="barValue" v-on:change="updateBar($event)">
       <option v-for="(item,index2) in barList" :key="index2" class="card mx-3" :value="item._id">{{item.name}}</option>
    </select>
  </div>
</template>

<script>
import barService from "../api/bar.js"

export default {
  name: 'SelectBar',
   props: {
      venueId: {
        type: String, // Define the expected type
      },
      liveOrder: {
        type: Boolean, // Define the expected type
        default: false // Provide a default value
      },
      includeHeader:{
        type: Boolean, // Define the expected type
        default: true // Provide a default value
      },
      loadValue:{
        type: String, // Define the expected type
      },
      loadBar:{
         type: Boolean,
      },
      optional:{
        type: Boolean,
         default: false // Provide a default value
      }
  },
    data() {
    return {
      barList: [],
      barValue:'0',
      tracker:0
    };
  },
  mounted(){
     if (this.$props.loadValue && this.$props.loadValue.trim() !== '') {
        // 🔥 Property is not empty — do something
        console.log('Property changed and is NOT empty:', this.$props.loadValue);
        this.barValue=this.$props.loadValue
      }
  },
    watch: {
    venueId: {
      immediate: true, // To trigger the watcher immediately on component mount
      handler(newVenueID) {
        // Handle the change in venueID
        this.fetchOrders(newVenueID);
      },
    },
     loadValue(newVal) {
      if (newVal && newVal.trim() !== '') {
        // 🔥 Property is not empty — do something
        console.log('Property changed and is NOT empty:', newVal);
        this.barValue=newVal
      }
    },
  },
  methods:{
    updateBar(e){
        this.$emit("updateBar",e)
    },
    async fetchOrders(){
         barService.getAllBars(this.$props.venueId).then(data =>{
            this.barList = data
            this.barList.unshift({_id:0,name:"Please Select a Location"});
            if(this.$props.liveOrder){
              console.log('')
              this.barList.push({_id:this.$props.venueId,name:"Table Orders"})
            }
            this.tracker++
         }) 

        
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
